import styled from 'styled-components';

interface ToggleButtonProps {
  isSelected: boolean;
}

interface SlidingBackgroundProps {
  selectedIndex: number;
  totalOptions: number;
}

export const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ToggleContainer = styled.div`
  position: relative;
  display: flex;
  background: transparent;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  width: fit-content;
`;

export const SlidingBackground = styled.div<SlidingBackgroundProps>`
  position: absolute;
  top: 4px;
  left: 4px;
  height: calc(100% - 8px);
  width: calc(${({ selectedIndex }) => {
    switch (selectedIndex) {
      case 0:
        return '27';
      case 1:
        return '33';
      case 2:
        return '44.3333';
      default:
        return '33.3333';
    }
  }}% - 8px);
  background: ${({ theme }) => theme.cardText};
  border-radius: 6px;
  transform: translateX(${({ selectedIndex }) => {
    switch (selectedIndex) {
      case 0:
        return '0';
      case 1:
        return '79';
      case 2:
        return '132';
      default:
        return '0';
    }
  }}%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
  position: relative;
  z-index: 2;
  padding: 10px 24px;
  border: none;
  background: transparent;
  color: ${({ isSelected, theme }) => (isSelected ? theme.cardBg : theme.cardText)};
  font-weight: ${({ isSelected }) => (isSelected ? '700' : '600')} !important;
  font-size: 16px !important;
  cursor: pointer;
  transition: color 0.3s ease;
  white-space: nowrap;
  flex: 1;

  &:hover {
    color: ${({ isSelected, theme }) => (isSelected ? theme.cardBg : theme.cardTextAlt)};
  }
`;
